import axios, { defaultParams } from './axios';
export default function patch(url, body, config) {
    const mergedConfig = { ...defaultParams(), ...(config ?? {}) };
    return axios.patch(url, body, mergedConfig);
}
